import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Typography from 'components/global/Typography';

export const ItemButton = styled(Button)`
	width: 100%;
	height: ${({ height }) => `${height}rem`};
	background: var(--white) !important;
	border: 1.5px solid ${({ selected }) => (selected ? 'var(--blue)' : 'var(--border-color)')} !important;

	svg {
		font-size: ${({ iconSize }) => `${iconSize}rem`} !important;
		color: var(--black);
	}
	:hover {
		background-color: unset !important;
	}
`;

export const SlaceText = styled(Typography)`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-top: 1rem;
	color: ${({ selected }) => (selected ? 'var(--blue)' : 'var(--black)')};
`;

export const ScaleContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	text-align: center;
`;

export const GridScaleContainer = styled.div`
	width: 100%;
	display: grid;
	padding-top: 0.7rem;
	grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
	overflow: auto;
	gap: 2rem;
`;

export const GridThemeContainer = styled.div`
	width: 100%;
	display: flex;
	padding-top: 0.7rem;

	flex-wrap: wrap;
	overflow: auto;
	gap: 2rem;
`;

export const ThemeContainer = styled.div`
	width: fit-content;
	display: flex;
	flex-direction: column;
	text-align: center;
`;
